import React from "react";
import { useState,useEffect } from "react";
import { Button ,Typography, Avatar,Input,PageHeader, Menu ,Spin} from "antd";
import {Link} from 'react-router-dom';
import icon  from '../images/cryptocurrency.png';
import { HomeOutlined,MoneyCollectOutlined,BulbOutlined,FundOutlined, MenuOutlined } from "@ant-design/icons/lib/icons";
const NavBar =()=>{

    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(null);
  
    useEffect(() => {
      const handleWindowSize = () => setScreenSize(window.innerWidth);
      window.addEventListener('resize', handleWindowSize);
      handleWindowSize();
      return () => window.removeEventListener('resize', handleWindowSize);
    }, []);
    useEffect(() => {
      if (screenSize <= 800) {
        setActiveMenu(false);
      } else {
        setActiveMenu(true);
      }
    }, [screenSize]);

    return(

        <div className="nav-container">
            <div className="logo-container">
                <Avatar src={icon} size="large"/>
                <Typography.Title level={2} className="logo"> 
                    <Link to="/">CryptoWorld</Link>
                </Typography.Title>
                <Button
          className="menu-control-container"
          onClick={() => setActiveMenu(!activeMenu)}
        >
          <MenuOutlined />
        </Button>
            </div>

            
            {activeMenu && (
            <Menu theme="dark">
                <Menu.Item  icon={<HomeOutlined />}>    
                    <Link to="/">Home</Link>
                </Menu.Item>
                <Menu.Item  icon={<FundOutlined />}>    
                    <Link to="/cryptocurencies">Cryptocurencies</Link>
                </Menu.Item>
                <Menu.Item  icon={<MoneyCollectOutlined />}>    
                    <Link to="/exchanges">Exchanges</Link>
                </Menu.Item>
                <Menu.Item  icon={<BulbOutlined />}>    
                    <Link to="/news">News</Link>
                </Menu.Item>
                  
            </Menu>)}
        </div>
    )
}

export default NavBar;
